import React, { SyntheticEvent, memo, useState } from 'react'
import { useAuthContext } from '@app/components/providers/auth'
import { useTranslation } from '@app/lib/hooks/useTranslation'
import {
  ProfileInputCell,
  profileCellSubmitStyle,
} from '../general/cells/profile-input'
import { User } from '@app/types'
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from '@app/@/components/ui/alert-dialog'
import { twMerge } from 'tailwind-merge'

const DatalessViewComponent = ({
  storageless,
  onDataLessEvent,
  user,
  loading,
}: {
  user?: User
  loading?: boolean
  storageless?: boolean
  onDataLessEvent(e: SyntheticEvent<HTMLButtonElement>): Promise<any>
}) => {
  const { t } = useTranslation('settings')
  const { account } = useAuthContext()
  const [modalOpen, setModalOpen] = useState<boolean>(false)

  const { activeSubscription } = account ?? {}

  const onOpenChange = (v: boolean) => {
    setModalOpen(v)
  }

  const onConfirm = (e: any) => {
    onDataLessEvent(e)
    setModalOpen(false)
  }

  return (
    <AlertDialog onOpenChange={onOpenChange} open={modalOpen}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>{t('dataless')}</AlertDialogTitle>
        </AlertDialogHeader>
        <AlertDialogDescription>
          {t(!storageless ? 'confirm-dataless-switch' : 'dataless-v-details')}
        </AlertDialogDescription>
        <AlertDialogFooter>
          <AlertDialogCancel>{t('go-back')}</AlertDialogCancel>
          <AlertDialogAction onClick={onConfirm}>
            {t(!storageless ? 'dataless-now' : 'dataless-revert')}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>

      <ProfileInputCell
        title={t('dataless')}
        disabledWall={!activeSubscription}
        subTitle={t(
          activeSubscription ? 'dataless-details' : 'dataless-upgrade'
        )}
        skeletonLoad={!user && loading}
        submitLabel={{
          disabled: !activeSubscription,
          // title: `${t('notification-settings')}`,
          submit: (
            <AlertDialogTrigger className={twMerge(profileCellSubmitStyle)}>
              {`${t(storageless ? 'disabled' : 'enabled')}`}
            </AlertDialogTrigger>
          ),
        }}
      />
    </AlertDialog>
  )
}

export const DatalessView = memo(DatalessViewComponent)
